module.exports = __webpack_public_path__ + "static/media/gb-sct.6231d4d5.svg";